var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPncLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.57135 13.7007C4.82039 13.7007 3.16437 13.0121 1.93027 11.7619C0.685614 10.5118 0 8.85904 0 7.10035C0 5.33108 0.685614 3.67834 1.93027 2.42819C3.16437 1.17805 4.82039 0.5 6.57135 0.5C8.3223 0.5 9.97832 1.17805 11.223 2.42819C12.4571 3.67834 13.1427 5.33108 13.1427 7.10035C13.1427 8.85904 12.4571 10.5118 11.223 11.7619C9.97832 13.0121 8.3223 13.7007 6.57135 13.7007ZM6.57135 12.2175C5.21067 12.2175 3.92382 11.6878 2.96396 10.7237C2.0041 9.74897 1.46616 8.46704 1.46616 7.10035C1.46616 5.72307 2.0041 4.44114 2.96396 3.46645C3.92382 2.50235 5.21067 1.97263 6.57135 1.97263C7.93202 1.97263 9.21887 2.50235 10.1787 3.46645C12.1723 5.46881 12.1723 8.72131 10.1787 10.7237C9.21887 11.6878 7.93202 12.2175 6.57135 12.2175ZM12.6364 14.3258C12.552 14.3258 12.4676 14.294 12.4043 14.2304L10.9909 12.8108C11.2335 12.6201 11.455 12.4294 11.666 12.2069C11.9086 11.9738 12.1195 11.7195 12.32 11.4547L13.7439 12.8849C13.8705 13.0121 13.8705 13.2134 13.7439 13.3405C13.6806 13.3935 13.6068 13.4253 13.5224 13.4253C13.4486 13.4253 13.3853 13.4041 13.3326 13.3617L12.9212 13.8702C12.9739 13.9868 12.9528 14.1245 12.8579 14.2304C12.7946 14.294 12.7102 14.3258 12.6364 14.3258Z",
    fill: "url(#paint0_linear_1053_17172)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.634 18.5C16.2754 18.5 15.9273 18.3623 15.6742 18.0974L12.6997 15.1204C12.4465 14.8661 12.3094 14.5165 12.3094 14.1563C12.3094 13.7855 12.4465 13.4358 12.6997 13.1816C12.9634 12.9273 13.3009 12.779 13.6701 12.779C14.0393 12.779 14.3768 12.9273 14.6405 13.1816L17.6045 16.1586C18.1318 16.6989 18.1318 17.5677 17.6045 18.0974C17.3408 18.3623 17.0032 18.5 16.634 18.5ZM4.44067 9.24044C3.2593 8.05386 3.2593 6.13626 4.44067 4.94968C4.5567 4.82254 4.5567 4.62125 4.44067 4.50471C4.31409 4.37758 4.11368 4.37758 3.98711 4.50471C2.56314 5.93496 2.56314 8.25515 3.98711 9.6854C4.0504 9.74897 4.13478 9.78075 4.20861 9.78075C4.293 9.78075 4.37738 9.74897 4.44067 9.6854C4.5567 9.56886 4.5567 9.36757 4.44067 9.24044Z",
    fill: "url(#paint1_linear_1053_17172)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1053_17172",
    x1: 9,
    y1: 0.5,
    x2: 9,
    y2: 18.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B20000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1053_17172",
    x1: 9,
    y1: 0.5,
    x2: 9,
    y2: 18.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B20000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPncLogin);
export default __webpack_public_path__ + "static/media/pncLogin.4523cfca17e39e556e297592a2aa3fbe.svg";
export { ForwardRef as ReactComponent };